import { getLayout } from './layout';
import type { Guest } from '../types';

export function validateSeatPair(
  table: number | null,
  seat: number | null
): string | null {
  const both = table !== null && seat !== null;
  const neither = table === null && seat === null;
  return both || neither ? null : 'Please provide both table and seat numbers, or leave both empty';
}

export function validateSeatRange(
  table: number,
  seat: number
): string | null {
  const L = getLayout();
  
  // Find the table configuration
  const tableConfig = L.tables.find(t => t.tableNumber === table);
  if (!tableConfig) {
    const maxTable = Math.max(...L.tables.map(t => t.tableNumber));
    return `Table number must be between 1 and ${maxTable}`;
  }
  
  // Determine max seats for this table type
  let maxSeats: number;
  switch (tableConfig.type) {
    case 'rectangle_6':
      maxSeats = 6;
      break;
    case 'rectangle_7':
      maxSeats = 7;
      break;
    case 'round':
      maxSeats = 10;
      break;
    default:
      maxSeats = 0;
  }
  
  if (seat < 1 || seat > maxSeats) {
    return `Seat number must be between 1 and ${maxSeats} for table ${table}`;
  }
  
  return null;
}

export function isSeatOccupied(
  occupiedSeats: Set<string>,
  table: number,
  seat: number,
  ignoreSeatKey?: string | null
): boolean {
  const key = `${table}-${seat}`;
  return occupiedSeats.has(key) && key !== ignoreSeatKey;
}

export function isDuplicateName(
  allGuests: Guest[],
  name: string,
  editingId?: number
): boolean {
  const lc = name.trim().toLowerCase();
  return allGuests.some(g => g.fullName.trim().toLowerCase() === lc && g.id !== editingId);
}

export function parseIntOrNull(s: string): number | null {
  const t = s.trim();
  if (!t) return null;
  const n = parseInt(t, 10);
  return Number.isNaN(n) ? null : n;
}
